import React, { FC, useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { IRootReducers } from 'src/reducers';
import {
  IChallengeResourceRender,
  IAddressData,
  IChallengeCheckoutPayment,
} from 'src/shared/models';
import CheckoutPayment from '../experienceCheckout/CheckoutPayment';
import CompletedCheckoutPayment from '../experienceCheckout/CompletedCheckoutPayment';

interface OwnProps extends IChallengeResourceRender {
  config: IChallengeCheckoutPayment;
}

const mapStateToProps = (state: IRootReducers) => {
  return { user: state.auth.user };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface ICheckoutData {
  products: number[];
  productsEan?: string[];
  address?: IAddressData;
}

const ChallengeCheckoutPayment: FC<Props> = ({
  config,
  updateChallenge,
  updateUserPoints,
  user,
}) => {
  const [loading, setLoading] = useState(false);
  const [showCompletedModal, setShowCompletedModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [checkoutData, setCheckoutData] = useState<ICheckoutData>({
    products: [],
  });

  const { product, isCompleted } = config;

  useEffect(() => {
    if (product.idResource) {
      setCheckoutData((prevData) => {
        return {
          ...prevData,
          products: [product.idResource],
          productsEan: [product.id],
        };
      });
    }
  }, []);

  const checkoutComponent = isCompleted ? (
    <CompletedCheckoutPayment
      {...{
        config,
        setShowCompletedModal,
        showCompletedModal,
      }}
    />
  ) : (
    <CheckoutPayment
      {...{
        checkoutData,
        config,
        loading,
        setLoading,
        setShowModal,
        showModal,
        updateChallenge,
        updateUserPoints,
        user,
      }}
    />
  );
  return checkoutComponent;
};

export default connect(mapStateToProps, {})(ChallengeCheckoutPayment);
